// defaults
import React from 'react';
import ReactDom from 'react-dom';
import App from './app';

ReactDom.render(
  <App></App>,
  document.querySelector('#app')
);